var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ConfirmDialog',{ref:"confirmDialog",attrs:{"title":"Eliminar Registro","text":"¿Está seguro que desea eliminar este registro? Esta acción no se puede deshacer."},on:{"close":_vm.close,"confirm":_vm.confirm}})}
var staticRenderFns = []

export { render, staticRenderFns }